import { Grid } from '@material-ui/core';
import { useAppSelector } from '../../../../app/hooks';
import { formatarCep } from '../../../../common/formatadores';
import Card from '../../../../components/Card/Card';
import FieldGroup from '../../../../components/FieldGroup/FieldGroup';
import { selectEndereco } from '../../consultaCompletaSlice';

const IdentificacaoEndereco: React.FC = () => {
  const endereco = useAppSelector(selectEndereco);

  const montarNomeLogradouro = (endereco: any) => {
    if (!endereco || !endereco.nomeLogradouro) return "-"

    let preNomeLogradouro: String = "";

    if (endereco.nomeTipologradouro) preNomeLogradouro = endereco.nomeTipologradouro + " ";

    if (endereco.nomeTituloLogradouro) preNomeLogradouro += endereco.nomeTituloLogradouro + " ";

    const logradouro = preNomeLogradouro + endereco.nomeLogradouro;

    if (!logradouro) {
      return "-";
    }

    return logradouro;
  }

  return (
    <>
      {endereco && (
        <Card>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FieldGroup label="Localidade (bairro, povoado, vila, etc)" value={endereco.localidade} />
            </Grid>
            <Grid item xs={12}>
              <FieldGroup label="Logradouro (tipo, título, nome)" value={montarNomeLogradouro(endereco).toUpperCase()} />
            </Grid>
            <Grid item xs={6}>
              <FieldGroup label="Número" value={endereco.numeroLogradouro} />
            </Grid>
            <Grid item xs={6}>
              <FieldGroup label="Complemento do número" value={endereco.complementoNumero} />
            </Grid>
            <Grid item xs={12}>
              <FieldGroup label="Complemento adicional" value={endereco.complementoAdicional} />
            </Grid>
            <Grid item xs={12}>
              <FieldGroup label="Referência para localização" value={endereco.referenciaLocalizacao} />
            </Grid>
            <Grid item xs={12}>
              <FieldGroup label="Município" value={endereco.municipio} />
            </Grid>
            <Grid item xs={6}>
              <FieldGroup label="UF" value={endereco.uf} />
            </Grid>
            <Grid item xs={6}>
              <FieldGroup label="CEP" value={formatarCep(endereco.cepLogradouro)} />
            </Grid>
          </Grid>
        </Card>
      )}
    </>
  );
};

export default IdentificacaoEndereco;
